import React, { useState, forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { Nav, Collapse } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));

const NavigationListItem = props => {
  const {
    title,
    href,
    depth,
    children,
    icon: Icon,
    open: openProp,
    label: Label
  } = props;

  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen(open => !open);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = {
    paddingLeft
  };

  if (children) {
    return (
      <div>
        <div
          className="nav-link rounded-1	d-flex justify-content-between align-items-center small"
          onClick={handleToggle}
          style={{ ...style, cursor: 'pointer', color: '#ffffff' }}
        >
          <div className="d-flex align-items-center" style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
            {Icon && <Icon className="me-2" style={{ color: "#ffffff" }} />}
            {title}
          </div>
          {open ? (
            <FaChevronUp size={14} />
          ) : (
            <FaChevronDown size={14} />
          )}
        </div>
        <Collapse in={open}>
          <div style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>{children}</div>
        </Collapse>
      </div>
    );
  } else {
    return (
      <Nav.Item className="nav-item-custom">
        <Nav.Link
          as={CustomRouterLink}
          to={href}
          style={style}
          className={`nav-link-custom rounded-1 depth-${depth} small py-2`}
          activeClassName="active-nav-link"
        >
          <div className="d-flex align-items-center" style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
            {Icon && <Icon className="me-2 nav-icon" />}
            <span className="nav-title">{title}</span>
            {Label && (
              <span className="ms-auto">
                <Label />
              </span>
            )}
          </div>
        </Nav.Link>
      </Nav.Item>
    );
  }
};

export default NavigationListItem;
